import {
    Check,
    Monitor,
    Moon,
    Sun,
} from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
    type Theme,
    useTheme,
} from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';

const OPTIONS: { value: Theme; label: string; icon: typeof Sun }[] = [
    { value: 'light', label: 'Light', icon: Sun },
    { value: 'dark', label: 'Dark', icon: Moon },
    { value: 'system', label: 'System', icon: Monitor },
];

export function ThemeToggle() {
    const { theme, resolvedTheme, setTheme } = useTheme();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    className="relative h-9 w-9 rounded-full text-muted-foreground"
                    aria-label="Toggle theme"
                >
                    <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
                    <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                className="w-40 bg-card border-border/60 shadow-lg"
                align="end"
            >
                {OPTIONS.map((option) => {
                    const isSelected = theme === option.value;
                    const Icon = option.icon;
                    const handleSelect = () => setTheme(option.value);
                    return (
                        <DropdownMenuItem
                            key={option.value}
                            onClick={handleSelect}
                            className={cn(
                                'cursor-pointer gap-2 rounded-md',
                                isSelected && 'text-primary',
                            )}
                        >
                            <Icon className="h-4 w-4" />
                            <span className="flex-1">{option.label}</span>
                            {isSelected && <Check className="h-3.5 w-3.5" />}
                        </DropdownMenuItem>
                    );
                })}
                <div className="px-2 py-1.5 text-[11px] text-muted-foreground border-t border-border/60 mt-1">
                    {`Currently ${resolvedTheme}`}
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
